export enum RepositoryKey {
  VERSION = 'version',
  SELECTED_ENTITY = 'selectedEntity',
  ENTITIES = 'entities',
}
